import { __extends } from "tslib";
import { deserializeAws_restJson1PostTextCommand, serializeAws_restJson1PostTextCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PostTextCommand = /** @class */ (function (_super) {
    __extends(PostTextCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PostTextCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PostTextCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PostTextCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1PostTextCommand(input, context);
    };
    PostTextCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1PostTextCommand(output, context);
    };
    return PostTextCommand;
}($Command));
export { PostTextCommand };
//# sourceMappingURL=PostTextCommand.js.map